import { InlineError, Input } from 'avo-ui'
import Select from 'components/commons/select'
import ModalForm from 'components/commons/modal-form'
import Timepicker from 'components/commons/timepicker'

export const FormStore = ({
    show,
    onHideForm,
    dataStore,
    options,
    onSearchOptions,
    isLoading,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={`${!dataStore?.id ? 'Create' : 'Update'} Store`}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama Store</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama store'}
                        value={dataStore?.name}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.name} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Kota</div>
                    <Select
                        name={'city_id'}
                        className={'flex-1'}
                        optionsClassName={'max-h-40'}
                        placeholder={'Pilih kota'}
                        options={options}
                        searchable
                        value={dataStore?.city_id}
                        onChange={onChangeForm}
                        onSearch={(keyword) => onSearchOptions(keyword)}
                    />
                    <InlineError className='mt-2' message={errorForm?.city_id} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Alamat Store</div>
                    <Input
                        type={'text-area'}
                        className={'flex-1'}
                        name={'address'}
                        placeholder={'Masukkan alamat store'}
                        value={dataStore?.address}
                        row={5}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.address} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90'}>No. Telepon</div>
                    <Input
                        type={'tel'}
                        addonBefore={'+62'}
                        className={'flex-1'}
                        name={'phone_number'}
                        placeholder={'Masukkan no. telepon'}
                        maxLength={14}
                        value={dataStore?.phone_number}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.phone_number} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Jam Operasional</div>
                    <div className={'flex space-x-2 items-center'}>
                        <div className={'flex-1 flex-col space-y-3 self-start'}>
                            <Timepicker
                                className={'flex-1'}
                                name={'opening_time'}
                                placeholder='Jam buka'
                                value={dataStore?.opening_time}
                                onChange={onChangeForm}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.opening_time} />
                        </div>
                        <div className={(errorForm?.opening_time || errorForm?.closing_time) && '-mt-7'}>-</div>
                        <div className={'flex-1 flex-col space-y-3 self-start'}>
                            <Timepicker
                                className={'flex-1'}
                                name={'closing_time'}
                                placeholder='Jam tutup'
                                value={dataStore?.closing_time}
                                onChange={onChangeForm}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.closing_time} />
                        </div>
                    </div>
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Link Maps</div>
                    <Input
                        className={'flex-1'}
                        name={'map_url'}
                        placeholder={'Masukkan link maps'}
                        value={dataStore?.map_url}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.map_url} />
                </div>
            </div>
        </ModalForm>
    )
}
